<template>
  <div>
    <p class="m-3">
      {{
        ft(featureName, 'reportingChannels.phoneCall.confirmDescription', $t, {
          organizationTitle: organizationFullName
        })
      }}
    </p>
  </div>
</template>
<script>
import LocalizableComponent from './LocalizableComponent.vue'

export default {
  name: 'PhoneCallConfirm',
  extends: LocalizableComponent,
  props: {
    organizationFullName: {
      type: String,
      default: ''
    },
    featureName: {
      type: String,
      default: ''
    }
  }
}
</script>
<style></style>
